import React from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../src/login.css";
import { useState } from "react";
import { BaseAPIURL } from "../API/base";
import toast, { Toaster } from "react-hot-toast";
import Loader from "./global-components/loader";
import AuthWrapper from "./AuthWrapper";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { persistToken, persistUserInfo } from "../utils/rememberMe";

const Login = () => {
  let history = useHistory();
  let location = useLocation();
  // Set (as router state) by whichever page sent the visitor here to log in,
  // e.g. "Book Now" on an excursion they weren't signed in for. Falls back
  // to home when someone just navigates to /login directly.
  const returnTo = location.state?.from || "/";
  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: "",
  });
  const [isValid, setIsValid] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const fetchUserData = async (token) => {
    try {
      const response = await fetch(BaseAPIURL + "account", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (data.name) {
        persistUserInfo(data, rememberMe);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleLogin = async () => {
    setIsLoading(true);
    let path = returnTo;

    try {
      const response = await fetch(BaseAPIURL + "account/app/sign-in", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginDetails),
      });

      const data = await response.json();

      if (data.accessToken) {
        persistToken(data.accessToken, rememberMe);
        await fetchUserData(data.accessToken);
        history.push(path);
        toast.success("Login successful!");
      } else {
        toast.error("We couldn't log you in.\nCheck your credentials and try again.");
      }
    } catch (err) {
      setIsValid(false);
      toast.error("We couldn't log you in.\n Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <AuthWrapper>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="login-content">
        <h2 style={{ textAlign: "center" }}>Login</h2>
        {!isValid ? (
          <p
            style={{
              marginTop: 20,
              color: "red",
              padding: 5,
              textAlign: "center",
            }}
          >
            Invalid login credentials
          </p>
        ) : null}
        <div className="col-lg-12 ">
          <form action="#">
            <div className="col-lg-12">
              <label className="single-input-wrap">
                <span className="single-input-title">Email</span>
                <input
                  type="email"
                  placeholder="Enter email"
                  value={loginDetails.email}
                  onChange={(e) =>
                    setLoginDetails({
                      ...loginDetails,
                      email: e.target.value,
                    })
                  }
                />
              </label>
            </div>
            <div className="col-lg-12">
              <label className="single-input-wrap">
                <span className="single-input-title">Password</span>
                <div style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={loginDetails.password}
                    onChange={(e) =>
                      setLoginDetails({
                        ...loginDetails,
                        password: e.target.value,
                      })
                    }
                    style={{ paddingRight: "40px" }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "16px",
                      color: "#666",
                      padding: "0",
                      outline: "none",
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </label>
            </div>

            <div className="col-lg-12">
              <label className="remember-me-row" htmlFor="remember-me">
                <input
                  id="remember-me"
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                Keep me signed in
              </label>
            </div>

            <div className="col-lg-12">
              <button type="button" className="signinButt" onClick={handleLogin}>
                Sign In
              </button>
            </div>

            <br />

            <div className="col-lg-12">
              <div style={{ textAlign: "center", cursor: "pointer" }}>
                <Link to="/forgot-password">
                  <h6
                    style={{ marginBottom: 20, fontSize: 14, color: "#01b9b7" }}
                  >
                    Forgot Password?
                  </h6>
                </Link>
              </div>
            </div>

            <br />

            <div className="col-lg-12">
              <div style={{ textAlign: "center", cursor: "pointer" }}>
                <Link to={{ pathname: "/signup", state: location.state }}>
                  <h6 style={{ marginBottom: 30 }}>
                    Don't have an account? Signup
                  </h6>
                </Link>

                <Link to="/">
                  <h6 style={{ fontSize: 12, textDecoration: "underline" }}>
                    Back to Homepage
                  </h6>
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </AuthWrapper>
  );
};

export default Login;
